import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchRoles, deleteRole } from "actions/role";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class RoleIndex extends Component {
  componentDidMount() {
    this.props.fetchRoles();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchRoles({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { roleURL: role_url } = this.props.match.params;
    this.props.fetchRoles({ role_url, page, ...this.search });
  };

  handleRoleDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteRoleProcess(id);
      },
      title: "Delete role",
      body: "Are you sure you want to delete this role?"
    });
  };

  deleteRoleProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteRole, match } = this.props;
    const { roleURL: role_url } = match.params;
    deleteRole(id, { role_url })
      .then(() => {
        this.props.fetchRoles({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Role Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { roles } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table roles={roles} onClickDelete={this.handleRoleDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={roles.current_page}
            lastPage={roles.last_page}
            range="4"
            modifyClasses="is-right"
          /> 
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authRole, roles, confirmationPopupActive }) => ({
  authRole,
  roles,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchRoles, deleteRole, toggleconfirmationPopup, toggleNotification }
)(RoleIndex);



// WEBPACK FOOTER //
// ./src/pages/Role/Index/index.js